import styled, { css } from 'styled-components';
import { playGrey10 } from '../design-tokens';
import { device } from '../breakpoints';
import { calc } from '../helpers';
import { regularOutline } from '../typography/helpers';
import { Heading } from './components/Caption/Caption.styles';

type ShowcaseCardProps = {
    big?: boolean;
    twoColumns?: boolean;
};

export const cssShowCaseCard = css`
    display: block;
    width: 100%;
    background: ${playGrey10};
    margin: 0 0 5px;

    @media ${device.GteSmall} {
        ${(props: ShowcaseCardProps) =>
            !props.big &&
            css`
                display: inline-block;
                ${calc('width', '50% - 2.5px', '49.6%')};
            `}
    }

    @media ${device.GteLarge} {
        margin: 0 0 10px;

        ${(props: ShowcaseCardProps) =>
            !props.big &&
            css`
                display: inline-block;
                ${calc('width', '33.333% - 5px', '33%')};
            `}
    }

    ${(props: ShowcaseCardProps) =>
        props.twoColumns &&
        css`
            ${props.big &&
            css`
                display: inline-block;
                ${calc('width', '50% - 2.5px', '49.6%')};
            `}

            @media ${device.GteSmall} {
                ${props.big &&
                css`
                    ${calc('width', '33.333% - 2.5px', '33%')};
                `}
            }
        `}
`;

export const StyledShowcaseCard = styled.article`
    ${cssShowCaseCard}
`;

export const CardWrapper = styled.a`
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    text-decoration: none;

    &:focus {
        ${regularOutline()};
    }

    &:active {
        outline: 0;
    }

    &:hover ${Heading} {
        text-decoration: underline;
    }
`;
